var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_core.js
// module id = 23
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20